import { HttpResponse } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { getLocalStorage } from 'utils/sessionStorage';
import {
  AddressVinpayResponse,
  CreatePaypalRequestModel,
  CreatePaypalResponseModel,
  CreateTransactionRequestModel,
  DepositVinpayResponse,
  LinkDto,
  VinpayConnectRequestModel,
  WalletInfoVinpayResponse,
} from 'models/vinpay';

const vinpayApi = {
  connect: (request: VinpayConnectRequestModel): Promise<HttpResponse<{}>> => {
    const url = '/wallet/api/vinpay/connect';
    return handleRequest(
      axiosClient.post(url, request, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  disconnect: (): Promise<HttpResponse<{}>> => {
    const url = '/wallet/api/vinpay/disconnect';
    return handleRequest(
      axiosClient.post(url, null, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  createTransaction: (request: CreateTransactionRequestModel): Promise<HttpResponse<{}>> => {
    const url = '/wallet/api/vinpay/create-transaction';
    return handleRequest(
      axiosClient.post(url, request, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  paypalDeposit: (
    request: CreatePaypalRequestModel,
  ): Promise<HttpResponse<CreatePaypalResponseModel>> => {
    const url = '/wallet/api/partners/deposit/paypal';
    return handleRequest(
      axiosClient.post(url, request, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getVinpayWallet: (): Promise<HttpResponse<WalletInfoVinpayResponse>> => {
    const url = '/wallet/api/partners/wallet/info';
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getVinpayAddress: (
    assetId: number,
    request: CreatePaypalRequestModel,
  ): Promise<HttpResponse<DepositVinpayResponse>> => {
    const url = `/wallet/api/partners/deposit/address/${assetId}`;
    return handleRequest(
      axiosClient.post(url, request, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  updateAutoTransfer: () => {
    const url = '/wallet/api/partners/update/auto-transfer';
    return handleRequest(
      axiosClient.post(url, null, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
  getOnramperLink: (): Promise<HttpResponse<LinkDto>> => {
    const url = '/wallet/api/partners/onramper';
    return handleRequest(
      axiosClient.get(url, {
        headers: {
          Authorization: `Bearer ${getLocalStorage('access_token_terabet')}`,
        },
      }),
    );
  },
};

export default vinpayApi;
